module.exports = "/_next/static/images/og-image-f42af8c4145325d19450f9281bf24bb1.png";